import styled from 'styled-components';
import { attachLocale, attachSubcategorySlug, trackAnalytics } from '../../../../lib/utils';
import { DOM_SITEMAP_CATEGORY_SECTION } from '../../../../lib/constants';
import { SiteMapAnchor, SiteMapAnchorGroup } from './sitemap.shared';

const CategoryGroupHeaderDiv = styled.div`
  margin-bottom: ${p => p.theme.unit(2)};
  margin-top: ${p => p.theme.unit(4)};
`;

const CategoryNameSpan = styled.span`
  ${({ theme }) => theme.typographyRebrand.heading.xl}
  color: ${({ theme }) => theme.c.text.primary};
`;

const SiteMapCategoryGroup = (props) => {
  const {
    category,
    locale,
    globalPageConfig,
    isMobile = false,
  } = props;

  const categoryDirectoryParentCategoryPrefix = globalPageConfig.categoryDirectoryParentCategoryPrefix || 'All';
  const categorySlug = category.slug || '';
  const categoryName = category.name || '';

  // Sub category links
  let subCategories = category.subCategories || [];
  subCategories = subCategories
    // Filter out subcategories with no name (oddly all parent categories seem to need an empty subcateogry...)
    .filter((subCategory) => {
      return subCategory.name.trim().length > 0;
    })

    .map((subCategory) => {
      const {
        tags = {},
        slug = '',
        name = '',
      } = subCategory;

      const resolvedSubCategoryLink = attachSubcategorySlug(categorySlug, slug);
      const resolvedLocaleLink = attachLocale(resolvedSubCategoryLink, locale);
      const track = trackAnalytics(DOM_SITEMAP_CATEGORY_SECTION, `CategoryGroupSubCategory-${slug}`, resolvedLocaleLink, tags);

      return (
        <SiteMapAnchor
          key={`sub-category-anchor-${slug}`}
          href={track.url}
          data-track-id={track.dataTrackingId}
          data-track-click={track.dataTrack}
        >
          {name}
        </SiteMapAnchor>
      );
    });

  // Generate Link for parent category and place it as the first link
  const resolvedLocaleLink = attachLocale(`categories/${categorySlug}`, locale);
  const track = trackAnalytics(DOM_SITEMAP_CATEGORY_SECTION, `CategoryGroupSubCategory-${categorySlug}`, resolvedLocaleLink, category.tags);

  const parentCategory = (
    <SiteMapAnchor
      key={`sub-category-anchor-${categorySlug}`}
      href={track.url}
      data-track-id={track.dataTrackingId}
      data-track-click={track.dataTrack}>
      {categoryDirectoryParentCategoryPrefix} {categoryName}
    </SiteMapAnchor>
  );
  subCategories = [parentCategory, ...subCategories];

  return (
    <div>
      <CategoryGroupHeaderDiv>
        <CategoryNameSpan isMobile={isMobile}>{categoryName}</CategoryNameSpan>
      </CategoryGroupHeaderDiv>
      <SiteMapAnchorGroup>
        {subCategories}
      </SiteMapAnchorGroup>
    </div>
  );
};

export default SiteMapCategoryGroup;
